import { render, staticRenderFns } from "./extractResult.vue?vue&type=template&id=0ff12540&scoped=true"
import script from "./extractResult.vue?vue&type=script&lang=js"
export * from "./extractResult.vue?vue&type=script&lang=js"
import style0 from "./extractResult.vue?vue&type=style&index=0&id=0ff12540&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff12540",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ff12540')) {
      api.createRecord('0ff12540', component.options)
    } else {
      api.reload('0ff12540', component.options)
    }
    module.hot.accept("./extractResult.vue?vue&type=template&id=0ff12540&scoped=true", function () {
      api.rerender('0ff12540', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/doubleRandom/projectExtract/extractResult.vue"
export default component.exports